import React from 'react';
import { Box, Grid2 } from '@mui/material';
import CustomDialog from '@ui-components/Dialog/CustomDialog';
import CustomDialogContent from '@ui-components/Dialog/CustomDialogContent';
import CustomDialogActions from '@ui-components/Dialog/CustomDialogActions';
import CustomButton from '@ui-components/Button/CustomButton';
import CustomTypography from '@ui-components/Typography/CustomTypography';
import WarningIcon from '@assets/images/warning.svg';

interface WarningDialogProps {
  alertAccept: { message: string } | null;
  onClose: () => void;
  buttonText?: string;
}

const WarningDialog: React.FC<WarningDialogProps> = ({
  alertAccept,
  onClose,
  buttonText,
}) => {
  return (
    <CustomDialog
      id="acceptWarning"
      open={Boolean(alertAccept)}
      onClose={onClose}
    >
      <CustomDialogContent className="dialog-width">
        <Box className="pb-12">
          <WarningIcon />
          <Box className="float-right">{/* <CrossIcon /> */}</Box>
        </Box>
        <Box className="pb-4">
          <CustomTypography id="dialog-title-popup" variant="subtitle1">
            Alert
          </CustomTypography>
        </Box>
        <Box>
          <CustomTypography id="dialog-message-popup" variant="body3">
            {alertAccept?.message}
          </CustomTypography>
        </Box>
      </CustomDialogContent>

      <CustomDialogActions>
        <Grid2 container>
          <Grid2>
            <CustomButton
              id="btnOk"
              color="primary"
              variant="contained"
              onClick={onClose}
            >
              {buttonText}
            </CustomButton>
          </Grid2>
        </Grid2>
      </CustomDialogActions>
    </CustomDialog>
  );
};

export default WarningDialog;
